import {InView} from "react-intersection-observer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/pro-solid-svg-icons";
import React, {forwardRef} from "react";

type InfiniteLoadTriggerType = {
    loaded: number;
    totalCount: number;
    hasNextPage: any;
    fetchNextPage: any;
    isFetchingNextPage: any;
    extraClass?: string;
    hideLabel?: boolean;
}

const InfiniteLoadTrigger = forwardRef((props: InfiniteLoadTriggerType, ref: any) => {
    if(!ref) return null;

    return (
        <InView
            as={'div'}
            root={ref.current}
            rootMargin={'250px'}
            delay={100}
            className={`flex-row justify-between flex-gap-md p-md fade ${props.extraClass ? props.extraClass: ''}`}
            onChange={(inView) => inView && props.hasNextPage ? props.fetchNextPage() : null}>
            <h6>{props.isFetchingNextPage && <FontAwesomeIcon icon={faSpinner} fixedWidth={true} spin={true} className={'mr-sm'} />} {!props.hideLabel ? `${props.loaded}/${props.totalCount} ${props.totalCount === 1 ? 'Item' : 'Items'}` : ''}</h6>
        </InView>
    )
});

export default InfiniteLoadTrigger